export default __webpack_public_path__ + "static/media/09.57f5d0e7.jpg";